import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/global.css"; // Import global styles
import "@fortawesome/fontawesome-free/css/all.min.css"; //Import FontAwesome
import "bootstrap-icons/font/bootstrap-icons.css"; // Import Bootstrap Icons
import "@fontsource/montserrat"; //Import Montserrat font

// Create a root element and render the App component
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
